import Axios from "axios";
import { SET_INV_GENERAL_REQUISITION_REPORT, UNSET_INV_GENERAL_REQUISITION_REPORT } from "@/store/mutation-types";
import { getInvGeneralRequisitionReport } from "@/store/api";

const state = { getInvGeneralRequisitionReport: {} };

const getters = {
  getInvGeneralRequisitionReport(state) {
    return state.getInvGeneralRequisitionReport;
  },
};

const mutations = {
  [SET_INV_GENERAL_REQUISITION_REPORT](state, data) {
    state.getInvGeneralRequisitionReport = data;
  },
  [UNSET_INV_GENERAL_REQUISITION_REPORT](state) {
    state.getInvGeneralRequisitionReport = {};
  },
};

const actions = {
  getInvGeneralRequisitionReport({ commit }, data) {
    return new Promise((resolve, reject) => {
      Axios.get(getInvGeneralRequisitionReport, { params: data })
        .then(function (response) {
          commit("SET_INV_GENERAL_REQUISITION_REPORT", response.data);
          resolve(response);
        })
        .catch(function (error) {
          commit("UNSET_INV_GENERAL_REQUISITION_REPORT");
          reject(error);
        })
        .then((always) => {});
    });
  },
};

export default { state, getters, actions, mutations };
